<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('admin.column.subColumn.add.back') }}</span>
    </div>
    <h4>{{ id ? $t('admin.column.subColumn.add.edit') : $t('admin.column.subColumn.add.create') }}</h4>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.column.subColumn.add.basicInfo') }}</div>
      <div class="list_wrap">
        <div class="list">
          <a-form-item class="full" :label="$t('admin.column.subColumn.add.name.label')" :colon="false">
            <a-input
              maxLength="10"
              allowClear
              :placeholder="$t('admin.column.subColumn.add.name.placeholder')"
              v-decorator="['title', { rules: [{ required: true, message: $t('admin.column.subColumn.add.name.required') }] }]"
            ></a-input>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('admin.column.subColumn.add.parentColumn.label')" :colon="false">
            <a-select
              allowClear
              v-decorator="['parent_id', { rules: [{ required: true, message: $t('admin.column.subColumn.add.parentColumn.required') }] }]"
              :placeholder="$t('admin.column.subColumn.add.parentColumn.placeholder')"
            >
              <a-select-option v-for="item in columnList" :key="item.id" :value="item.id" :disabled="item.status == 2">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('admin.column.subColumn.add.type.label')" :colon="false">
            <a-select
              allowClear
              v-decorator="['type', { rules: [{ required: true, message: $t('admin.column.subColumn.add.type.required') }] }]"
              :placeholder="$t('admin.column.subColumn.add.type.placeholder')"
              :disabled="id"
            >
              <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('admin.column.subColumn.add.status.label')" :colon="false">
            <a-select
              allowClear
              v-decorator="['status', { rules: [{ required: true, message: $t('admin.column.subColumn.add.status.required') }] }]"
              :placeholder="$t('admin.column.subColumn.add.status.placeholder')"
            >
              <a-select-option v-for="item in stateList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list" v-if="form.getFieldValue('type') === 5">
          <a-form-item class="full" :label="$t('admin.column.subColumn.add.externalLink.label')" :colon="false">
            <a-input
              allowClear
              :placeholder="$t('admin.column.subColumn.add.externalLink.placeholder')"
              v-decorator="[
                'link',
                {
                  rules: [
                    { required: true, message: $t('admin.column.subColumn.add.externalLink.required') },
                    { type: 'url', message: $t('admin.column.subColumn.add.externalLink.urlError') }
                  ]
                }
              ]"
            ></a-input>
          </a-form-item>
        </div>
        <div class="list" v-if="form.getFieldValue('type') === 90">
          <a-form-item class="full" :label="$t('admin.column.subColumn.add.domain.label')" :colon="false">
            <a-input
              allowClear
              maxLength="10"
              :placeholder="$t('admin.column.subColumn.add.domain.placeholder')"
              :addon-after="addonAfter"
              v-decorator="[
                'customDomainPrefix',
                {
                  rules: [
                    { required: true, message: $t('admin.column.subColumn.add.domain.required') },
                    { pattern: /^[a-zA-Z0-9]+$/, message: $t('admin.column.subColumn.add.domain.formatError') }
                  ]
                }
              ]"
            ></a-input>
          </a-form-item>
        </div>
        <div class="list" v-if="form.getFieldValue('type') === 91">
          <a-form-item :label="$t('admin.column.subColumn.add.jumpTo.label')" :colon="false">
            <a-select
              allowClear
              v-decorator="['is_jump', { rules: [{ required: true, message: $t('admin.column.subColumn.add.jumpTo.required') }] }]"
              :placeholder="$t('admin.column.subColumn.add.jumpTo.placeholder')"
            >
              <a-select-option value="1">
                {{ $t('admin.column.subColumn.add.jumpTo.schoolResource') }}
              </a-select-option>
              <a-select-option value="2">
                {{ $t('admin.column.subColumn.add.jumpTo.localResource') }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('admin.column.subColumn.add.sort.label')" :colon="false">
            <a-input
              min="0"
              maxLength="2"
              oninput="value=value.replace(/[^\d]/g,'')"
              allowClear
              :placeholder="$t('admin.column.subColumn.add.sort.placeholder')"
              v-decorator="['order']"
            ></a-input>
          </a-form-item>
        </div>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.column.subColumn.add.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import cookie from 'js-cookie'

import {
  columnSave,
  columnDetail,
  columnType,
  getPortalTopcolumnList,
  postPortalSubcolumnSave,
  getPortalSubcolumnDetail
} from '@/api/admin'
import md5 from 'md5'

export default {
  data() {
    return {
      typeList: [
        {
          id: 1,
          name: this.$t('admin.column.subColumn.types.news')
        },
        {
          id: 2,
          name: this.$t('admin.column.subColumn.types.experiment')
        },
        {
          id: 3,
          name: this.$t('admin.column.subColumn.types.video')
        },
        {
          id: 4,
          name: this.$t('admin.column.subColumn.types.platform')
        },
        {
          id: 5,
          name: this.$t('admin.column.subColumn.types.externalLink')
        },
        {
          id: 91,
          name: this.$t('admin.column.subColumn.types.resource')
        },
        {
          id: 92,
          name: this.$t('admin.column.subColumn.types.recruitment')
        }
      ],
      columnList: [],
      stateList: [
        {
          id: 1,
          name: this.$t('status.default.open')
        },
        {
          id: 2,
          name: this.$t('status.default.close')
        }
      ],
      id: undefined,
      addonAfter: '.' + location.hostname,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'subList'
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.id) {
            values.id = this.id
          }
          postPortalSubcolumnSave(values).then(res => {
            if (res.code == 200) {
              const tip = this.id ? 
                this.$t('admin.column.subColumn.add.success.edit') : 
                this.$t('admin.column.subColumn.add.success.create')
              this.$message.success(tip)

              this.$router.push({
                name: 'subList'
              })
            }
          })
        }
      })
    },
    getColumnDetail() {
      getPortalSubcolumnDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          let isJump = res.data.isJump
          this.form.setFieldsValue({
            title: res.data.title,
            status: res.data.status,
            type: res.data.type,
            parent_id: res.data.parentId,
            order: res.data.order
          })
          setTimeout(() => {
            this.form.setFieldsValue({
              is_jump: isJump == '0' ? undefined : isJump
            })
          }, 20)

          this.$nextTick(() => {
            if (res.data.type == 5) {
              this.form.setFieldsValue({
                link: res.data.link
              })
            }
            if (res.data.type == 90) {
              this.form.setFieldsValue({
                customDomainPrefix: res.data.customDomainPrefix
              })
            }
          })
        }
      })
    },
    async getTypeList() {
      const res = await getPortalTopcolumnList()
      if (res.code == 200) {
        this.columnList = res.data.list
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.form.setFieldsValue({
      is_click: '1'
    })
    if (this.id) {
      this.getColumnDetail()
    }
    this.getTypeList()
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .list_wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .list {
    width: 50%;
    .ant-form-item-label label {
      color: #000000;
    }
    .ant-form-item {
      width: 100%;
      padding-left: 45px;
      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button {
    width: 100%;
    // padding-left: 500px;
    text-align: center;
    margin-top: 19%;
  }
}
</style>
